import axios from 'axios';
import { BASE_URL } from '@/api/config';

// 创建axios实例
const service = axios.create({
  baseURL: BASE_URL, // 使用config.js中定义的BASE_URL
  timeout: 15000, // 请求超时时间
  withCredentials: false // 解决CORS问题，不发送cookie
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    
    // 如果返回的状态码不是1，则判断为错误
    if (res.code !== 1) {
      console.error('API错误:', res.msg || '未知错误');
      
      // 如果是未登录或token失效
      if (res.code === 401) {
        // 清除本地token
        localStorage.removeItem('token');
        // 跳转到登录页
        window.location.href = '/login';
      }
      
      return Promise.reject(new Error(res.msg || '未知错误'));
    } else {
      return res;
    }
  },
  error => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default service; 